function DashboardController($scope, $http, config, $translate) {
    $translate.use(ttb.constants.cultureName)
    $scope.hideSprintedItems = true;

    $http.get(config.getDashboardFilter)
        .then(function (response) {
            $scope.filter = response.data;

            var teams = $scope.filter.availableTeams,
                selectedTeam = $scope.filter.selectedTeam;
            if (teams) {
                for (var i = 0; i < teams.length; i++) {
                    if (selectedTeam && teams[i].id === selectedTeam.id) {
                        $scope.filter.selectedTeam = teams[i];
                        break;
                    }
                }
            }
            if (config.isIterationBasedProject ) {
                getTeamActiveSprint($scope.filter.selectedTeam);
            }
        });

    $scope.onSelectedTeam = function () {
        if (config.isIterationBasedProject && ($scope.filter.availableTeams.length <= 1 || ($scope.filter.selectedTeam && $scope.filter.selectedTeam.id ))) {
            getTeamActiveSprint($scope.filter.selectedTeam);
        }
        else {
            $scope.hideSprintedItems = true
            $scope.activeTeamSprint = '';
        }

        saveDashboardFilter();
    }

    function saveDashboardFilter() {
        $http.post(config.setDashboardFilter, { selectedTeam: $scope.filter.selectedTeam });
    }

    function getTeamActiveSprint(team) {
            $http.get(config.getActiveStrintUrl, { params: { teamId: team ? team.id : null } })
                .then(function (response) {
                    if(team && team.id || response.data.id)
                    {
                        $scope.activeTeamSprint = response.data;
                    }
                    $scope.hideSprintedItems = !response.data.id;
                });
    }
}

DashboardController.$inject = ['$scope', '$http', 'config','$translate'];

module.exports = DashboardController;


// WEBPACK FOOTER //
// ./components/dashboard-page/dashboard.controller.js